import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  warningIcon: {
    display: 'block',
    color: theme.custom.darkBlue,
  },
  text: {
    margin: 0,
    marginBottom: 15,
    fontSize: 16,
    color: theme.custom.darkBlue,
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  btn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 'auto',
    minHeight: 35,
    padding: '5px 15px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    borderRadius: 29,
    color: '#fff',
    textDecoration: 'none',
    textTransform: 'uppercase',
    background: theme.custom.accept,
  },
}));
